import * as Yup from "yup";

export const USER_SCHEMA_UPDATE_YUP = Yup.object().shape({
  fullname: Yup.string().required('Los nombres son obligatorios'),
  lastname: Yup.string().required('Los apellidos son obligatorios'),
});